// extracted by mini-css-extract-plugin
export default {"card":"L3OcVJzW","technicianRow":"DG57oFgA","avatar":"VkXPnpWp","info":"TBM9JB2L","name":"pKCjFstr","ratingRow":"Ib_1mlHV","rate":"MHTzjS0q","reviewCount":"iJZ4m1MT"};